export const LIVE_PREVIEW_MOBILE_INDEX = 1;
export const LIVE_PREVIEW_DESKTOP_INDEX = 0;
export const DESKTOP_PRIMARY_IMAGE_INDEX = 0;
export const VIDEO_TYPE = 'video';
export const IMAGE_CAROUSEL_TEST_SKUS = ['hardcover', 'layflat'];
